export const GeneratedCertificateRegistry = `GeneratedCertificateRegistry/`;
export const Search = GeneratedCertificateRegistry + 'Search';